<app-navbar-style-one></app-navbar-style-one>

<div class="home-slider owl-carousel owl-theme">
    <div class="slider-item" 
        style="background-image: url('../../../assets/img/home2/profile.jpg');background-size: 100%;background-position: top;">
        <div class="d-table">
            <div class="d-table-cell">
                <div class="container">
                    <div class="slider-content">
                        <h1>My Account</h1>
                        <p>"Welcome to your account! Edit your profile information!"</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<section class="account-section mt-5 mb-5">
  <div class="container-fluid">
    <div class="row">
      <!-- Sidebar Navigation -->
      <div class="col-lg-3 col-md-3 mt-3">
        <div class="nav flex-column nav-pills account-nav" id="v-pills-tab" role="tablist" aria-orientation="vertical">
          <button class="nav-link active" id="v-pills-home-tab" data-bs-toggle="pill" 
                  data-bs-target="#v-pills-home" type="button" role="tab" 
                  aria-controls="v-pills-home" aria-selected="true">
            <i class="bx bx-user-circle me-2"></i> My Account
          </button>
          <button class="nav-link" id="v-pills-profile-tab" data-bs-toggle="pill" 
                  data-bs-target="#v-pills-profile" type="button" role="tab" 
                  aria-controls="v-pills-profile" aria-selected="false">
            <i class="bx bx-shopping-bag me-2"></i> My Orders
          </button>
          <button class="nav-link" id="v-pills-address-tab" data-bs-toggle="pill" 
                  data-bs-target="#v-pills-address" type="button" role="tab" 
                  aria-controls="v-pills-address" aria-selected="false">
            <i class="bx bx-map me-2"></i> My Addresses
          </button>
        </div>
      </div>
      
      <!-- Account Content -->
      <div class="col-lg-9 col-md-9 mt-3">
        <div class="tab-content account-content" id="v-pills-tabContent">
          <div class="tab-pane fade show active" id="v-pills-home" role="tabpanel" 
               aria-labelledby="v-pills-home-tab" tabindex="0">
                <div class="account-card" *ngIf="profileDetails && !isLoading">
                    <h2 class="account-title">Account Details</h2>
                
                    <!-- Profile Image -->
                     <form [formGroup]="profileImage" class="text-center mb-4">
                        <div class="profile-image-container">
                            <img [src]="profileImagePreview || profileDetails.avatar" class="profile-image" alt="Profile">
                            <label for="profileImageUpload" class="btn btn-sm btn-light change-image-btn">
                                <i class="bx bx-camera"></i>
                            </label>
                            <label (click)="removeProfileImage()" class="btn btn-sm btn-light remove-image-btn">
                                <i class="bx bx-trash"></i>
                            </label>
                        </div>
                        <input 
                            type="file" 
                            id="profileImageUpload" 
                            class="d-none" 
                            accept="image/*"
                            (change)="onFileSelected($event)"
                            #fileInput
                        >
                    </form>
                    <!-- <form [formGroup]="profileImage" class="text-center mb-4">
                        <div class="profile-image-container">
                            <img src="{{profileDetails.avatar}}" class="profile-image" alt="Profile">
                            <label for="profileImageUpload" class="btn btn-sm btn-light change-image-btn">
                                <i class="bx bx-camera"></i>
                            </label>
                        </div>
                        <input type="file" id="profileImageUpload" class="d-none" accept="image/*">
                    </form> -->
                
                    <!-- Account Form -->
                    <form [formGroup]="accountForm">
                        <div class="row">
                            <div class="col-md-6 mb-3">
                                <label class="form-label">Full Name</label>
                                <input type="text" class="form-control" placeholder="Enter your name" name="name" formControlName="name">
                            </div>
                            <div class="col-md-6 mb-3">
                                <label class="form-label">Phone Number</label>
                                <input type="tel" class="form-control" placeholder="Enter your phone number" name="phone" formControlName="phone" (input)="formatPhoneNumber($event)">
                            </div>
                        </div>

                        <div class="mb-3">
                            <label class="form-label">Second Phone Number</label>
                            <input type="text" class="form-control" placeholder="Enter your second phone number" name="sec_phone" formControlName="sec_phone" (input)="formatPhoneNumber($event)">
                        </div>
                        
                        <!-- <div class="mb-3">
                            <label for="gender" class="form-label">Gender</label>
                            <select class="form-control w-100" id="gender" formControlName="gender" name="gender">
                                <option value="">Please select your gender</option>
                                <option value="male">Male</option>
                                <option value="female">Female</option>
                            </select>
                        </div> -->
                        
                        <div class="mb-3">
                            <label class="form-label">Address</label>
                            <input type="text" class="form-control" placeholder="Enter your address" disabled value="{{myAddresse}}">
                            <div class="mt-0">
                                <small class="text-success">If you want to change your address or add new address, please go to addresses tab.</small>
                            </div>
                        </div>
                        
                        <div class="mb-3">
                            <label class="form-label">Email Address</label>
                            <input type="email" class="form-control" placeholder="Enter your email" disabled value="{{profileDetails.email}}">
                        </div>
                        
                        <div class="mb-4">
                            <label class="form-label">Password</label>
                            <button class="btn btn-primary ms-3" (click)="togglePasswordForm()" *ngIf="!changePasswordToggle">
                                Change Password
                            </button>
                            <!-- <button class="btn btn-primary ms-3" id="changePass" (click)="changePasswordToggleInput()">Change Password</button> -->
                            <!-- <small class="text-muted">Leave blank to keep current password</small> -->
                        </div>
                        <form [formGroup]="passwordForm" *ngIf="changePasswordToggle">
                            <div class="mb-3">
                                <label class="form-label">Old Password <span class="text-danger">*</span></label>
                                <input type="password" placeholder="Enter your old password" 
                                    formControlName="old_password" class="form-control">
                                <div *ngIf="passwordForm.get('old_password')?.hasError('required') && passwordForm.get('old_password')?.touched" 
                                    class="text-danger">
                                    Old Password is required
                                </div>
                            </div>
                            
                            <div class="mb-3">
                                <label class="form-label">New Password <span class="text-danger">*</span></label>
                                <input type="password" placeholder="Enter your new password" 
                                    formControlName="new_password" class="form-control">
                                <div *ngIf="passwordForm.get('new_password')?.hasError('required') && passwordForm.get('new_password')?.touched" 
                                    class="text-danger">
                                    New Password is required
                                </div>
                                <div *ngIf="passwordForm.get('new_password')?.hasError('minlength')" class="text-danger">
                                    Password must be at least 8 characters
                                </div>
                            </div>
                            
                            <div class="mb-3">
                                <label class="form-label">Confirm New Password <span class="text-danger">*</span></label>
                                <input type="password" placeholder="Confirm your new password" 
                                    formControlName="new_password_confirmation" class="form-control">
                                <div *ngIf="passwordForm.get('new_password_confirmation')?.hasError('required') && passwordForm.get('new_password_confirmation')?.touched" 
                                    class="text-danger">
                                    Password confirmation is required
                                </div>
                                <div *ngIf="passwordForm.hasError('mismatch')" class="text-danger">
                                    Passwords do not match
                                </div>
                            </div>
                            
                            <div class="d-flex gap-2">
                                <button class="btn btn-primary" (click)="submitPasswordForm()" [disabled]="isSavingPassword">
                                    <span *ngIf="isSavingPassword" class="spinner-border spinner-border-sm"></span>
                                        {{ isSavingPassword ? 'Saving...' : 'Save Password' }}
                                </button>
                                
                                <button type="button" class="btn btn-secondary" (click)="togglePasswordForm()" [disabled]="isSavingPassword">
                                    Cancel
                                </button>
                            </div>
                        </form>
                        <!-- <form [formGroup]="passwordForm" *ngIf="changePasswordToggle">
                            <div class="mb-3">
                                <label class="form-label">Old Password <span class="text-danger">*</span></label>
                                <input type="password" placeholder="Enter your old password" name="old_password" formArrayName="old_password" class="form-control">
                                <div *ngIf="passwordForm.get('old_password')?.hasError('required') && passwordForm.get('old_password')?.touched" class="text-danger">
                                    Old Password is required
                                </div>
                            </div>
                            <div class="mb-3">
                                <label class="form-label">New Password</label>
                                <input type="password" placeholder="Enter your new password" name="new_password" formArrayName="new_password" class="form-control">
                                <div *ngIf="passwordForm.get('new_password')?.hasError('required') && passwordForm.get('new_password')?.touched" class="text-danger">
                                    New Password is required
                                </div>
                            </div>
                            <div class="mb-3">
                                <label class="form-label">New Password Confirmation</label>
                                <input type="password" placeholder="Enter your new password confirmation" name="new_password_confirmation" formArrayName="new_password_confirmation" class="form-control">
                                <div *ngIf="passwordForm.get('new_password_confirmation')?.hasError('required') && passwordForm.get('new_password_confirmation')?.touched" class="text-danger">
                                    New Password Confirmation is required
                                </div>
                            </div>
                        </form> -->
                        
                        <div class="d-flex justify-content-end">
                            <!-- <button type="button" class="btn btn-outline-secondary me-3">Cancel</button> -->
                            <button type="submit" class="btn btn-primary" (click)="changeProfileData()" [disabled]="isLoading">
                                <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-1"></span>
                                Save Changes
                            </button>
                        </div>
                    </form>

                    <div class="d-flex justify-content-center mt-4">
                        <div class="alert alert-danger">
                            <p class="textDeletion">If you deleted your account you will not be able to open your account again!!</p>
                            <button class="btn btn-danger mt-3" data-bs-toggle="modal" data-bs-target="#deleteAccountModal">Delete Account</button>
                        </div>
                    </div>
                </div>
                <div class="account-card text-center" *ngIf="isLoading">
                    <div class="spinner-grow" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                </div>
          </div>
          
            <div class="tab-pane fade" id="v-pills-profile" role="tabpanel" 
                aria-labelledby="v-pills-profile-tab" tabindex="0">
                    <div class="row" *ngIf="ordersLength > 0">
                        <div class="col-lg-6" *ngFor="let order of myOrders">
                            <div class="order-card mt-3">
                                <a href="order-details/{{order.orderId}}" class="w-100">
                                    <div class="order-header">
                                        <img src="../../../../assets/img/logo.png" alt="Vendor Logo" class="vendor-avatar">
                                        <div class="vendor-info">
                                            <h3>BAYONNE BBQ & WINGS</h3>
                                            <span class="order-id">#{{order.orderId}}</span>
                                        </div>
                                        <div class="order-status status-canceled" *ngIf="order.status == 'canceled'">
                                            {{ 'canceled' | titlecase }}
                                        </div>
                                        <div class="order-status status-ordered" *ngIf="order.status == 'ordered'">
                                            {{ 'ordered' | titlecase }}
                                        </div>
                                        <div class="order-status status-success" *ngIf="order.status == 'accepted'">
                                            {{ 'accepted' | titlecase }}
                                        </div>
                                    </div>
                                    
                                    <div class="order-details">
                                        <div class="order-time">
                                            <i class="bx bx-calendar-alt"></i>
                                            <span>{{ order.orderedAt | date:'dd MMM yyyy' }}</span>
                                            <i class="bx bx-alarm"></i>
                                            <span>{{ order.orderedAt | date:'hh:mm a' }}</span>
                                        </div>
                                    </div>
                                </a>
                            
                                <div class="order-actions">
                                    <button *ngIf="order.status !== 'canceled'" 
                                        (click)="cancelOrder(order.orderId)"
                                        class="btn-action btn-cancel">
                                        <i class="bx bx-x"></i> Cancel
                                    </button>
                                    <button (click)="reorder(order.orderId)"
                                        class="btn-action btn-reorder">
                                        <i class="bx bx-redo"></i> Reorder
                                    </button>
                                    <button (click)="deleteOrder(order.orderId)"
                                        class="btn-action btn-delete">
                                        <i class="bx bx-trash-alt"></i> Delete
                                    </button>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="col-lg-6">
                            <div class="order-card">
                                <a href="order-details/2" class="w-100">
                                    <div class="order-header">
                                        <img src="../../../../assets/img/home2/personPlaceholder.png" alt="Vendor Logo" class="vendor-avatar">
                                        <div class="vendor-info">
                                            <h3>Jimmy John’s </h3>
                                            <span class="order-id">#124</span>
                                        </div>
                                        <div class="order-status status-ordered">
                                            {{ 'ordered' | titlecase }}
                                        </div>
                                    </div>
                                    
                                    <div class="order-details">
                                        <div class="order-time">
                                            <i class="bx bx-calendar-alt"></i>
                                            <span>{{ '2022-05-01' | date:'dd MMM yyyy' }}</span>
                                            <i class="bx bx-clock"></i>
                                            <span>{{ '10:00 AM' | date:'hh:mm a' }}</span>
                                        </div>
                                    </div>
                                </a>
                            
                                <div class="order-actions">
                                    <button class="btn-action btn-cancel">
                                        <i class="bx bx-x"></i> Cancel
                                    </button>
                                    <button class="btn-action btn-reorder">
                                        <i class="bx bx-redo"></i> Reorder
                                    </button>
                                    <button class="btn-action btn-delete">
                                        <i class="bx bx-trash-alt"></i> Delete
                                    </button>
                                </div>
                            </div>
                        </div> -->
                    </div>
                    <div class="row" *ngIf="ordersLength == 0">
                        <div class="col-12">
                            <div class="alert alert-danger">
                                You have no orders yet
                            </div>
                        </div>
                    </div>
            </div>

            <div class="tab-pane fade" id="v-pills-address" role="tabpanel" 
                aria-labelledby="v-pills-address-tab" tabindex="0">
                <!-- Loading State -->
                <div class="text-center py-4" *ngIf="isLoading && !allAddresses">
                    <div class="spinner-border text-primary" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                </div>

                <!-- Addresses List -->
                <div class="row" *ngIf="allAddresses && allAddresses.length > 0">
                    <div class="col-lg-6 col-md-6 mb-4" *ngFor="let address of allAddresses">
                        <div class="card h-100" [class.border-primary]="address.isMain">
                            <div class="card-body">
                                <div class="d-flex justify-content-between align-items-start">
                                    <h5 class="card-title">{{address.city | titlecase}}</h5>
                                    <span *ngIf="address.isMain" class="badge bg-primary">Main</span>
                                </div>
                                <p class="card-text">{{address.address}}</p>
                            </div>
                            <div class="card-footer bg-transparent">
                                <!-- <button class="btn btn-sm btn-outline-primary me-2" (click)="editAddress(address)">
                                    <i class="bx bx-edit"></i> Edit
                                </button> -->
                                <button class="btn btn-sm btn-outline-danger me-2" (click)="deleteAddress(address.id)" 
                                        *ngIf="!address.isMain" [disabled]="isLoading">
                                    <i class="bx bx-trash"></i> Delete
                                </button>
                                <button class="btn btn-sm" 
                                        [class.btn-primary]="!address.isMain"
                                        [class.btn-success]="address.isMain"
                                        (click)="setAsMain(address.id)" 
                                        [disabled]="isLoading || address.isMain">
                                    <i class="bx" [class.bx-check]="address.isMain" [class.bx-star]="!address.isMain"></i>
                                    {{ address.isMain ? 'Main Address' : 'Set as Main' }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                 <div class="card mt-4">
                    <div class="card-header bg-primary text-white">
                        <h5 class="mb-0">Add New Address</h5>
                    </div>
                    <div class="card-body">
                        <form [formGroup]="newAddressForm" (ngSubmit)="submitAddress()">
                            <div class="row">
                            <!-- Country Dropdown -->
                                <div class="col-md-12 mb-3">
                                    <label class="form-label">Country <span class="text-danger">*</span></label>
                                    <select class="form-control w-100" formControlName="country_id" (change)="onCountryChange($event.target)">
                                        <option value="" disabled selected>Select Country</option>
                                        <option *ngFor="let country of allCountries" [value]="country.id">
                                            {{ country.name }}
                                        </option>
                                    </select>
                                    <!-- {{ allCountries[0].name }} -->
                                    <div *ngIf="newAddressForm.get('country_id')?.hasError('required') && newAddressForm.get('country_id')?.touched" 
                                        class="text-danger small mt-1">
                                        Country is required
                                    </div>
                                </div>

                                <!-- City Dropdown -->
                                <div class="col-md-12 mb-3" >
                                    <label class="form-label">City <span class="text-danger">*</span></label>
                                    <select class="form-control w-100" formControlName="city_id">
                                        <option value="" disabled selected>Select City</option>
                                        <option *ngFor="let city of cities" [value]="city.id">
                                            {{ city.name }}
                                        </option>
                                    </select>
                                    <div *ngIf="newAddressForm.get('city_id')?.hasError('required') && newAddressForm.get('city_id')?.touched" 
                                        class="text-danger small mt-1">
                                        City is required
                                    </div>
                                </div>

                                <!-- Address with Autocomplete -->
                                <div class="col-12 mb-3">
                                    <label class="form-label">Address <span class="text-danger">*</span></label>
                                    <input type="text" id="addressInputAccount" formControlName="address" 
                                        class="form-control" placeholder="Start typing your address...">
                                    <div *ngIf="newAddressForm.get('address')?.hasError('required') && newAddressForm.get('address')?.touched" 
                                        class="text-danger small mt-1">
                                    Address is required
                                    </div>
                                </div>

                                <!-- Building, Floor, Flat -->
                                <div class="col-md-4 mb-3">
                                    <label class="form-label">Building</label>
                                    <input type="text" class="form-control" formControlName="building" placeholder="Building no.">
                                </div>

                                <div class="col-md-4 mb-3">
                                    <label class="form-label">Floor</label>
                                    <input type="text" class="form-control" formControlName="floor" placeholder="Floor no.">
                                </div>

                                <div class="col-md-4 mb-3">
                                    <label class="form-label">Flat</label>
                                    <input type="text" class="form-control" formControlName="flat" placeholder="Flat no.">
                                </div>

                                <!-- Special Mark -->
                                <div class="col-12 mb-3">
                                    <label class="form-label">Special Mark</label>
                                    <textarea class="form-control" formControlName="special_mark" 
                                            placeholder="Any special landmarks or directions"></textarea>
                                </div>

                                <!-- Submit Button -->
                                <div class="col-12 text-end">
                                    <button class="btn btn-primary" type="submit" [disabled]="isLoading">
                                        <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-1"></span>
                                        Save Address
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</section>

<div class="modal fade" id="deleteAccountModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="deleteAccountModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content border-danger">
      <div class="modal-header bg-danger text-white">
        <h1 class="modal-title fs-5" id="deleteAccountModalLabel">
          <i class="bi bi-exclamation-octagon-fill me-2"></i>Confirm Account Deletion
        </h1>
        <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="d-flex mb-3">
          <div class="me-3 text-danger">
            <i class="bi bi-exclamation-triangle-fill fs-1"></i>
          </div>
          <div>
            <h5 class="fw-bold mb-2">This action cannot be undone!</h5>
            <p class="mb-1">All your data will be permanently deleted, including:</p>
            <ul class="text-muted">
              <li>Your profile information</li>
              <li>All your saved content</li>
              <li>Account preferences</li>
              <li>Any connected services</li>
            </ul>
          </div>
        </div>
        
        <div class="alert alert-warning p-2 mb-0">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" id="confirmDeleteCheckbox" [(ngModel)]="deleteConfirmed">
            <label class="form-check-label" for="confirmDeleteCheckbox">
              I understand that this action is permanent and cannot be reversed
            </label>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">Cancel</button>
        <button [disabled]="!deleteConfirmed" type="button" class="btn btn-danger" id="confirmDeleteBtn" (click)="deleteAccount()">
          <i class="bi bi-trash-fill me-1"></i>Permanently Delete Account
        </button>
      </div>
    </div>
  </div>
</div>

<app-footer-style-two></app-footer-style-two>